module.exports = __webpack_public_path__ + "static/media/iptables.ff2486ee.png";